var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnestoreLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5C5.339 2.5 2.5 5.346 2.5 16C2.5 26.654 5.346 29.5 16 29.5C26.661 29.5 29.5 26.654 29.5 16C29.5 5.346 26.661 2.5 16 2.5Z",
    fill: "url(#paint0_linear_onestore_logo)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.933 18.006L11.933 29.315C13.141 29.443 14.493 29.5 16 29.5C26.661 29.5 29.5 26.654 29.5 16C29.5 11.904 29.08 8.962 27.958 6.892Z",
    fill: "url(#paint1_linear_onestore_logo)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.933 18.006L3.437 8.279C2.765 10.218 2.5 12.745 2.5 16C2.5 25.147 4.597 28.538 11.933 29.315Z",
    fill: "url(#paint2_linear_onestore_logo)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.201 8.296L11.35 11.093C10.496 11.586 10.197 12.689 10.69 13.55C11.183 14.404 12.287 14.702 13.147 14.209L17.249 11.842L15.299 13.932L15.299 22.157C15.299 23.142 16.111 23.954 17.097 23.954C18.082 23.954 18.894 23.142 18.894 22.157L18.894 9.85C18.894 9.503 18.783 9.17 18.658 8.948C18.152 8.101 17.055 7.796 16.201 8.296Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_onestore_logo",
    x1: 0.497,
    y1: 0.388,
    x2: 26.948,
    y2: 27.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3752D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_onestore_logo",
    x1: 7.877,
    y1: 9.017,
    x2: 21.402,
    y2: 20.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_onestore_logo",
    x1: 24.885,
    y1: 4.425,
    x2: 11.422,
    y2: 21.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnestoreLogo);
export default __webpack_public_path__ + "static/media/onestore_logo.94953485cac2b1b460ac91550369b1d4.svg";
export { ForwardRef as ReactComponent };